import { Box, Container, Typography, Grid } from '@mui/material';
import { motion } from 'framer-motion';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import ContactForm from '../../components/ContactForm';
import CTAButton from '../../components/CTAButton';
import SEO from '../../components/SEO';

const Fumigation = () => {
  return (
    <>
      <SEO 
        title="Fumigation Services in Kampala | Professional Pest Control Uganda"
        description="Expert fumigation & pest control services in Kampala. Safe, eco-friendly pest elimination for homes & businesses. Family & pet-safe solutions. Call 0752 058 190"
        keywords="fumigation services Kampala, pest control Uganda, termite treatment, bed bug removal Kampala, eco-friendly fumigation, professional pest control Uganda"
        url="https://blossomcleaningservices.com/services/fumigation"
      />
      <Header />

      <Box sx={{ position: 'relative', py: 12, backgroundImage: 'url(https://images.unsplash.com/photo-1563453392212-326f5e854473?w=1920&q=80)', backgroundSize: 'cover', backgroundPosition: 'center', '&::before': { content: '""', position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(34, 51, 95, 0.75)' } }}>
        <Container sx={{ position: 'relative', zIndex: 1 }}>
          <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8 }}>
            <Typography variant="h1" sx={{ mb: 3, color: 'white', fontSize: { xs: '2.5rem', md: '3.5rem' } }}>
              Fumigation Services
            </Typography>
            <Typography variant="h5" sx={{ maxWidth: 800, color: 'rgba(255,255,255,0.95)', mb: 4 }}>
              Professional pest control solutions for homes and businesses
            </Typography>
            <CTAButton to="/contact">Book Fumigation</CTAButton>
          </motion.div>
        </Container>
      </Box>

      <Box sx={{ py: 8 }}>
        <Container>
          <Typography variant="h3" sx={{ mb: 4, fontWeight: 600 }}>
            Safe & Effective Pest Control
          </Typography>
          <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.8 }}>
            Our fumigation services eliminate pests effectively using safe, environmentally friendly methods. We handle all types of pest infestations including rodents, insects, termites, and more.
          </Typography>
          <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.8 }}>
            Our certified technicians use the latest equipment and approved chemicals to ensure complete eradication while maintaining safety for your family and pets. We provide post-treatment follow-ups to ensure long-term protection.
          </Typography>
        </Container>
      </Box>

      <Box sx={{ py: 8, backgroundColor: 'background.paper' }}>
        <Container maxWidth="md">
          <ContactForm title="Request Fumigation Service" showServiceSelect={false} />
        </Container>
      </Box>

      <Footer />
    </>
  );
};

export default Fumigation;
